module.exports = __webpack_public_path__ + "img/PLACE_NEG_SIDE.1cc22653.svg";